import { MouseEventHandler } from 'react'

import clsx from 'clsx'

import { commaSeparatedNumber } from '@/common/util/number'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text from '@/components/view/atoms/text/Text'

interface Props {
  type?: 'default' | 'log'
  onClickPrev?: MouseEventHandler<HTMLButtonElement>
  onClickNext?: MouseEventHandler<HTMLButtonElement>
  onClickFirst?: MouseEventHandler<HTMLButtonElement>
  onClickLast?: MouseEventHandler<HTMLButtonElement>
  from: number
  to: number
  total?: number
}

const Pager = ({
  type = 'default',
  onClickPrev,
  onClickNext,
  onClickFirst,
  onClickLast,
  from,
  to,
  total
}: Props) => {
  const buttonClass = 'flex items-center p-1'
  const activeButtonClass =
    'bg-fill-tertiary hover:bg-fill-tertiary-hover active:bg-fill-tertiary-active'
  const disabledButtonClass = 'bg-fill-disabled pointer-events-none'
  return (
    <div className={clsx('flex items-center gap-x-2')}>
      <div className='flex items-stretch gap-x-0.5'>
        {type == 'default' && (
          <button
            type='button'
            className={clsx(
              buttonClass,
              'rounded-l-lg',
              onClickFirst ? activeButtonClass : disabledButtonClass
            )}
            onClick={onClickFirst}
          >
            <Icon
              color={onClickFirst ? IconColor.PRIMARY : IconColor.DISABLED}
              type={IconType.PAGE_FIRST}
            />
          </button>
        )}
        <button
          type='button'
          className={clsx(
            buttonClass,
            type == 'log' && 'rounded-l-lg',
            onClickPrev ? activeButtonClass : disabledButtonClass
          )}
          onClick={onClickPrev}
        >
          <Icon color={onClickPrev ? IconColor.PRIMARY : IconColor.DISABLED} type={IconType.LEFT} />
        </button>
        <button
          type='button'
          className={clsx(
            buttonClass,
            type == 'log' && 'rounded-r-lg',
            onClickNext ? activeButtonClass : disabledButtonClass
          )}
          onClick={onClickNext}
        >
          <Icon
            color={onClickNext ? IconColor.PRIMARY : IconColor.DISABLED}
            type={IconType.RIGHT}
          />
        </button>
        {type == 'default' && (
          <button
            type='button'
            className={clsx(
              buttonClass,
              'rounded-r-lg',
              onClickLast ? activeButtonClass : disabledButtonClass
            )}
            onClick={onClickLast}
          >
            <Icon
              color={onClickLast ? IconColor.PRIMARY : IconColor.DISABLED}
              type={IconType.PAGE_LAST}
            />
          </button>
        )}
      </div>
      <Text lineHeight={150} size={12}>
        {commaSeparatedNumber(from)}~{commaSeparatedNumber(to)}
        {type == 'default' && total && <> / {commaSeparatedNumber(total)}</>}
      </Text>
    </div>
  )
}

export default Pager
